<template>
  <div class="mt20 item-wrapper">
    <div class="delete-icon" @click.stop="deleteItem">
      <!--<Icon type="ios-trash-outline" size="30"></Icon>-->
      <img :src="deleteicon" alt="" style="width: 25px">
    </div>

    <Form class="form" ref="buildItem" :rules="formRules" :model="formData" :label-width="100" :inline="true">
      <FormItem label="楼栋名称" prop="buildingName">
        <Input class="input-long" v-model="formData.buildingName" :disabled="disabled"/>
      </FormItem>
      <br>
      <FormItem label="楼体结构" prop="buildingStructure">
        <Select class="select-width" v-model="formData.buildingStructure" :disabled="disabled">
          <Option value="">请选择</Option>
          <Option v-for="(item,index) in buildingStructureEnum " :value="item.value" :key="'structure'+index">{{item.text}}</Option>
        </Select>
      </FormItem>
      <FormItem label="朝向" prop="buildingDirection">
        <Select class="select-width" v-model="formData.buildingDirection" :disabled="disabled">
          <Option value="">请选择</Option>
          <Option v-for="(item,index) in directionEnum" :value="item.value" :key="'direc'+index">{{item.text}}</Option>
        </Select>
      </FormItem>
      <FormItem label="产权类型" prop="projectPropertyType">
        <Select class="select-width" v-model="formData.projectPropertyType" :disabled="disabled">
          <Option value="">请选择</Option>
          <Option v-for="(item,index) in propertyEnum" :value="item.value" :key="'proper'+index">{{item.text}}</Option>
        </Select>
      </FormItem>
      <br>
      <FormItem label="建成年代" prop="buildingFinishYear">
        <Input  class="input-short" v-model="formData.buildingFinishYear" :disabled="disabled"/>
      </FormItem>
      <FormItem label="建筑面积(㎡)" prop="buildingArea">
        <Input  class="input-short" v-model="formData.buildingArea"  :disabled="disabled"/>
      </FormItem>

      <FormItem label="外墙面积(㎡)" prop="buildingOutsidearea">
        <Input  class="input-short" v-model="formData.buildingOutsidearea" :disabled="disabled"/>
      </FormItem>
      <br>
      <FormItem label="电梯数" prop="buildingElevatornumber">
        <Input  class="input-short" v-model="formData.buildingElevatornumber" :disabled="disabled"/>
      </FormItem>

      <FormItem label="楼梯数" prop="buildingStairnumber">
        <Input  class="input-short" v-model="formData.buildingStairnumber" :disabled="disabled"/>
      </FormItem>
      <FormItem label="层高(m）" prop="buildingFloorheight">
        <Input  class="input-short" v-model="formData.buildingFloorheight" :disabled="disabled"/>
      </FormItem>
      <FormItem label="楼层数" prop="buildingFloornumber">
        <Input  class="input-short" v-model="formData.buildingFloornumber" :disabled="disabled"/>
      </FormItem>
      <br>
      <FormItem label="可出租楼层" prop="floorList">
        <div style="max-width: 70%">
          <CheckboxGroup v-if="floorList&&floorList.length>0" v-model="formData.floorList">

            <Checkbox :disabled="disabled"  v-for="(item,index) in floorList" :label="(index+1)+''" :key="'floor'+index">{{(index+1)+'层'}}</Checkbox>
          </CheckboxGroup>
        </div>
      </FormItem>
    </Form>
  </div>
</template>
<script>
  import {buildCondition} from "../../../../api/project";
  import  deleteicon from '../../../../assets/icon/icon_delete@2x.png'

  export default {
    // name: "BuildItem",
    props:{
      disabled:{
        type:Boolean,
        default:false
      },
      directionEnum:{
        type:Array,
        default:[]
      },
      propertyEnum:{
        type:Array,
        default:[]
      },
      buildingStructureEnum:{
        type:Array,
        default:[]
      },
      itemIndex:{
        type:Number,
        default:0
      },
      formData: {
        type:Object,
        default:null
      },
    },
    watch:{
      floorList(value){
        this.formData.floorList=[]
        value.forEach((ele,index)=>{
          this.formData.floorList.push((index+1)+'')
        })
      }
    },
    computed:{
      floorList(){
        var num=Number(this.formData.buildingFloornumber)
        if(num){
          num=num<=39?num:39
          return Array(num).fill(1)
        }
        return []
      }
    },
    data() {
      return {
        deleteicon:deleteicon,
        formRules: {
          "buildingArea": [
            {required: true, message: '', trigger: 'blur', validator:this.validateNumber2}
          ],
          // "buildingBusinessType": '',
          "buildingDirection": [
            {required: true, message: '', trigger: 'change',validator:this.validateNumber}
          ],
          "buildingElevatornumber": [
            {required: true, message: '', trigger: 'blur', validator:this.validateNumber}
          ],
          "buildingFinishYear": [
            {required: true, message: '', trigger: 'blur', validator:this.validateNumber}
          ],
          "buildingFloorheight": [
            {required: true, message: '',validator:this.validateNumber2, trigger: 'blur'}
          ],
          "buildingFloornumber": [
            {required: true, message: '',validator:this.validateNumber, trigger: 'blur'}
          ],
          "buildingName": [
            {required: true, message: ' ', trigger: 'blur', type: 'string'}
          ],
          "buildingOutsidearea": [
            {required: true, message: '', trigger: 'blur', validator:this.validateNumber}
          ],
          "buildingStairnumber": [
            {required: true, message: '', trigger: 'blur', validator:this.validateNumber}
          ],
          "buildingStructure": [
            {required: true, message: ' ', trigger: 'change',validator:this.validateNumber}
          ],
          "projectPropertyType": [
            {required: true,message: ' ', trigger: 'change',validator:this.validateNumber}
          ],
          floorList: [
            {required: true, message: ' ', trigger: 'change', type: 'array'}
          ]
        },
      }
    },
    methods: {

      validateNumber(rule, value, callback) {
        let pattern = /^\d+$/
        if (!pattern.test(value)) {
          callback(new Error('请输入正确数字'));
        }
        callback();
      },

      validateNumber2(rule, value, callback) {
        let pattern =/^(\d+)(\.\d+)?$/
        if (!pattern.test(value)) {
          callback(new Error('请输入正确数字'));
        }
        callback();
      },
      deleteItem(){
        this.$emit('deletebuild',this.itemIndex)
      }
    },
    created(){
    }
  }
</script>
<style scoped>
  .item-wrapper {
    /*padding-left: 20px;*/
    position: relative;
  }

  .delete-icon {
    /*float: left;*/
    /*display: inline-block;*/
    padding:3px 30px;
    font-size: 14px;
    /*border: 1px solid rgb(220,220,220);*/
    /*border-bottom: none;*/
    /*background-color: rgb(240,240,240);*/
    text-align: right;
    box-sizing: border-box;
    position: absolute;
    right: 30px;
    top: 10px;
  }
  .form {
    border: 1px solid rgb(220, 220, 220);
    overflow: auto;
    padding-top: 24px;
  }

  .input-long {
    width: 200px;
  }

  .select-width {
    width: 100px;
  }

  .input-short {
    width: 100px;
  }

</style>
